import { reconcile } from 'solid-js/store';

export interface ITypeOption<S = any> {
	label: string;
	init: S;
}

/* Patch a single field at sw.location (store + DB) */
export async function patchField(sw: any, field: string, value: any): Promise<void>
{
	sw.setStore(...sw.location, field, value);
	await sw.server.patch.mutate({page:sw.page, permission:sw.permission, id:sw.docId, location:sw.location, fields:{[field]:value}});
}

/* Replace a single field at sw.location (store + DB) — use instead of patchField when the value is an object, to avoid deepPatch merging stale keys */
export async function replaceField<S>(sw: any, field: string, value: S | undefined): Promise<void>
{
	sw.setStore(...sw.location, field, value === undefined ? undefined : reconcile(value));
	await sw.server.replace.mutate({page:sw.page, permission:sw.permission, id:sw.docId, location:[...sw.location, field], fields:value});
}

/* Replace the document at sw.location (store + DB) */
export async function replaceDoc<S>(sw: any, value: S | undefined): Promise<void>
{
	sw.setStore(...sw.location, value === undefined ? undefined : reconcile(value));
	await sw.server.replace.mutate({page:sw.page, permission:sw.permission, id:sw.docId, location:sw.location, fields:value});
}

/*
	Patch a field and replace a sibling subdoc at sw.location (store + DB).
	Sequential awaits prevent tRPC concurrent mutation races on the same doc.
*/
export async function updateFieldAndSubdoc<S>(sw: any, field: string, fieldValue: any, subdocName: string, subdocValue: S | undefined): Promise<void>
{
	sw.setStore(...sw.location, field, fieldValue);
	sw.setStore(...sw.location, subdocName, subdocValue === undefined ? undefined : reconcile(subdocValue));
	await sw.server.patch.mutate({page:sw.page, permission:sw.permission, id:sw.docId, location:sw.location, fields:{[field]:fieldValue}});
	await sw.server.replace.mutate({page:sw.page, permission:sw.permission, id:sw.docId, location:[...sw.location, subdocName], fields:subdocValue});
}

